<div class="form__group" [ngClass]="cssClass">
  <div class="form__label" [ngClass]="labelCssClass" [class.form__label_require]="require && !disabled" [class.form__label_error]="error">{{caption}}</div>
  @if (!disabled && (!triggerClick || !checked_option)) {
    <div class="form__input form__input_has-icon"
      [class.form__input_disabled]="disabled" tabindex="0"
      [class.form__input_error]="error"
      [class.form__input_focus]="focusing"
      [class.bg-transparent]="tblHeadStyle"
      (focus)="focusing = true"
      (blur)="focusing = false"
      [appDropdown]="'form__group__dropdown_opened'" [globalHide]="true"
      [targetElement]="dropdownWrapper">
      <div class="input__placeholder input__placeholder_pointer"
        [class.tbl-head-padding]="tblHeadStyle"
        >
        <div class="form__input_icon icon icon_Small_Dropdown"></div>
        @if (checked_option) {
          <span
            [class.tbl-head-caption]="tblHeadStyle"
            [class.clr-selected]="current_value"
            >
            @if (placeholder && !current_value) {
              {{placeholder}}
            }
            @if (!placeholder || current_value) {
              {{checked_option.caption}}
            }
          </span>
        }
      </div>
    </div>
    <ul [attr.data-caption]="caption" class="form__group__dropdown form__group__dropdown_ul form__group__dropdown_list"
      #dropdownWrapper>
      <li class="caption d-block-sm-fix d-md-none" (click)="onClose()">
        <i class="form__input_icon icon icon_Small_Dropdown_Back mr-2"></i><span>{{caption}}</span>
      </li>
      @for (option of options; track option) {
        <li [ngClass]="{'selected': option.checked}"
          (click)="onSelectChange(option)">
          <span>{{option.caption}}</span>
        </li>
      }
    </ul>
  }
  @if (!disabled && (triggerClick && checked_option)) {
    <div class="form__input form__input_has-icon"
      [class.form__input_disabled]="disabled" tabindex="0"
      [class.form__input_error]="error"
      [class.form__input_focus]="focusing">
      <div class="input__placeholder input__placeholder_pointer">
        <div class="form__input_icon icon icon_Small_Dropdown"
          (focus)="focusing = true"
          (blur)="focusing = false"
          [appDropdown]="'form__group__dropdown_opened'" [globalHide]="true"
        [targetElement]="dropdownWrapper"></div>
        @if (checked_option) {
          <span class="span_hover" (click)="onCallBack(checked_option.value)">{{checked_option.caption}}</span>
        }
      </div>
    </div>
    <ul [attr.data-caption]="caption" class="form__group__dropdown form__group__dropdown_ul form__group__dropdown_list" #dropdownWrapper>
      <li class="caption d-block-sm-fix d-md-none" (click)="onClose()">
        <i class="form__input_icon icon icon_Small_Dropdown_Back mr-2"></i><span>{{caption}}</span>
      </li>
      @for (option of options; track option) {
        <li [ngClass]="{'selected': option.checked}"
          (click)="onSelectChange(option)">
          <span>{{option.caption}}</span>
        </li>
      }
    </ul>
  }
  @if (disabled) {
    <div class="form__input form__input_has-icon form__input_disabled">
      <div class="input__placeholder input__placeholder_pointer">
        @if (checked_option) {
          <span>{{checked_option.caption}}</span>
        }
      </div>
    </div>
  }
</div>
<!-- // -->
<select #select [hidden]="true">
  <ng-content></ng-content>
</select>
